
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"15","viewBox":"0 0 20 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.663 5.65A6.145 6.145 0 009.545 0a6.094 6.094 0 00-5.882 4.398A5.457 5.457 0 000 9.545 5.46 5.46 0 005.455 15h8.863a4.778 4.778 0 004.773-4.773 4.752 4.752 0 00-3.428-4.576zm-2.76 2.111a.683.683 0 01-.63.42h-1.364v2.728a1.364 1.364 0 01-2.727 0V8.182H6.818a.683.683 0 01-.482-1.164l2.727-2.727a.68.68 0 01.964 0l2.728 2.727a.682.682 0 01.148.743z"}})])
          )
        }
      }
    